import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from "redux-thunk";
import WsGoalsComp from './components/ws-goals.component';
import ViewCascadeVisualizationComp from './components/okr/view-visual-cascade';
import { WbUniqueIdMixin } from './utils/common';
import okrDetailsReducer from "./reducers/goals/okrDetails.reducer";
import CommentsReducers from './reducers/comments.reducers';
import {okrDetailConstants} from "./constants/okr/okrDetails.constants";
import {commentsConstants} from "./constants/comments.constants";

const rootReducer = combineReducers({
  okrDetailsReducer,
  CommentsReducers
});

const goalStore = createStore(rootReducer, applyMiddleware(thunkMiddleware));

async function renderWsOKRPage(data) {
  const wsRootReducer = combineReducers({
    okrDetailsReducer,
    CommentsReducers
  });

  const wsGoalStore = createStore(wsRootReducer, applyMiddleware(thunkMiddleware));

  wsGoalStore.dispatch({type:okrDetailConstants.UPDATE_WORKSTREAM_PROPS,data});
  wsGoalStore.dispatch({type: commentsConstants.SET_USER_DATA,data});

  const mountId = document.getElementById('render-ws-okr-page');
  if (mountId) {
    ReactDOM.render(<Provider store={wsGoalStore}>
        <WsGoalsComp  />
    </Provider>, mountId);
  }
}

function renderViewCascadeVisualization(data) {
  const mountId = document.getElementById('view-cascade-tree');
  if (mountId) {
    ReactDOM.render(<ViewCascadeVisualizationComp key={WbUniqueIdMixin.randomId(`view_cascade_tree_${data.metricId}`)} {...data} />, mountId);
  }
}

window.renderWsOKRPage = renderWsOKRPage;
window.renderViewCascadeVisualization = renderViewCascadeVisualization;

export default goalStore;
